import { baseApi } from "configs/store-query";
import {
  AuthenticationSignOutApiRequest,
  AuthenticationSignOutApiResponse,
} from "apis/authentication/types/authentication-sign-out-api";
import {
  AuthenticationRefreshApiRequest,
  AuthenticationRefreshApiResponse,
} from "apis/authentication/types/authentication-refresh-api";

const BASE_PATH = "/authentication";

export const authenticationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Signs the current session out server-side, revoking its access and
     * refresh tokens so they can no longer be reused.
     */
    signOutAuthentication: build.mutation<
      AuthenticationSignOutApiResponse,
      AuthenticationSignOutApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-out`,
        method: "POST",
        ...config,
      }),
    }),
    /**
     * Exchanges a refresh token for a fresh access token, keeping the session
     * alive. The fulfilled response updates `authUser` via a store-slice matcher.
     */
    refreshAuthentication: build.mutation<
      AuthenticationRefreshApiResponse,
      AuthenticationRefreshApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/refresh`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
